export class AdStackLogger {


	constructor() {
		this.eventType =  'ADStackISM';
	}

	getSiteData() {
		const data = {};
		data['pageURL'] = location.href;
		data['SSOLoggedIn'] = window.hmUtils.isAUser();
		return data;
	}

	/**
	 * Log information to New Relic.
	 * window.hmLog is available when logging manager plugin is active.
	 * sendToNewRelic method logs data to new relic.
	 * @param data
	 * @return {boolean}
	 */
	logInfoToNewRelic( data ) {
		if( !data ) {
			return false;
		}
		const newRelicData = Object.assign( {}, {
			'eventType' : this.eventType,
		}, data );
		let newRelicFormatData = [ newRelicData ];
		window.hmLog && window.hmLog.sendToNewRelic( newRelicFormatData );
	}

	/**
   * Send registered services along with their response to New Relic on  Page Load
   * @return {Promise<void>}
   */
	async logDataOnPageLoad() {
		const data = this.getSiteData();
		await window.adstackData.ism.services.forEach( function( value ) {
			value.then( function( service ) {
				data[service.provider] = JSON.stringify( service.value );
			} );
		} );
		data['location'] = 'Page Load';
		this.logInfoToNewRelic( data );
	}
}
